<footer class="site-footer mt-5">
  <div class="container">
    <div class="row pt-4 align-items-center fw-lighter">
      <div class="col-12 col-md-8 d-md-flex align-items-center gap-3">
        <div class="newsletter-label">Recibe Liber en tu email</div>

        <form
          class="d-flex align-items-center pt-2 pt-md-0"
          (ngSubmit)="submit()"
        >
          <input
            type="email"
            name="email"
            [(ngModel)]="email"
            placeholder="micorreo@dominio.com"
            class="form-control me-2"
            required
          />

          <button type="submit" class="btn btn-primary" [disabled]="loading()">
            Enviar
          </button>
        </form>
      </div>
      <div class="col-12 col-md-4 pt-4 pt-md-0">
        <div class="text-center small">
          Redes Sociales de Arte &amp; Cultura
        </div>
        <ul
          class="d-flex list-unstyled mb-0 w-100 justify-content-center gap-3 pt-2"
        >
          @for (social of socialLinks; track social.url) {
            <li>
              <a
                [href]="social.url"
                target="_blank"
                rel="noopener"
                [attr.aria-label]="social.label"
              >
                <i [class]="social.icon"></i>
              </a>
            </li>
          }
        </ul>
      </div>
    </div>

    <div class="row pt-4 text-center">
      <div class="col-auto mx-auto">
        <div class="brand-partners">
          <a
            href="https://www.centroricardobsalinaspliego.org"
            target="_blank"
            rel="noopener"
          >
            <img src="/img/logo-salinas-white.webp" alt="Arte y Cultura" />
          </a>
          <a
            href="https://www.centroricardobsalinaspliego.org/arteycultura"
            target="_blank"
            rel="noopener"
          >
            <img
              src="/img/logo-arte-light.webp"
              alt="Centro Ricardo B. Salinas Pliego"
            />
          </a>
        </div>
      </div>
    </div>

    <div class="row pt-4 text-center">
      <div class="col small">
        Arte &amp; Cultura del Centro Ricardo B. Salinas Pliego es un programa
        de Fomento Cultural Grupo Salinas A.C.
      </div>
    </div>

    <div class="row text-center">
      <div class="col small">
        <a
          href="https://www.centroricardobsalinaspliego.org/arteycultura"
          target="_blank"
          rel="noopener"
          >Conozca más de Arte &amp; Cultura</a
        >.
      </div>
    </div>

    <div class="row py-4 gy-3 gy-sm-0 justify-content-evenly text-center small">
      <div class="col-5 col-sm-4 py-2 py-md-0">
        <a routerLink="/terminos-y-condiciones">Términos y Condiciones</a>
      </div>

      <div class="col-5 col-sm-4 py-2 py-md-0">
        <a routerLink="/aviso-de-privacidad">Aviso de Privacidad</a>
      </div>

      <div class="col-12 col-sm-4 py-2 py-md-0">
        &copy; Derechos Reservados Grupo Salinas
      </div>
    </div>
  </div>
</footer>
